import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { loadTours } from "../data/Tours";
import { mergeValenciaIfMissing } from "../data/valenciaTour";
import { fetchTours } from "../services/supabaseTours";
import { fetchTravelogues } from "../services/supabaseTravelogues";
import { fetchDestinations } from "../services/supabaseDestinations";
import { defaultTravelogues } from "../data/Travelogues";

const AppDataContext = createContext(null);

function normalizeTourTags(tours) {
  if (!Array.isArray(tours)) return tours;
  return tours.map((tour) => {
    if (!tour) return tour;
    if (tour.key === "alicante-maj" || tour.key === "madrid-segovia") {
      return { ...tour, tag: "Last Minute" };
    }
    return tour;
  });
}

export function AppDataProvider({ children }) {
  const [tours, setTours] = useState(() => loadTours());
  const [travelogues, setTravelogues] = useState(() => defaultTravelogues);
  const [destinations, setDestinations] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadData = useCallback(async () => {
    if (!process.env.REACT_APP_SUPABASE_URL) {
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const [toursData, traveloguesData, destinationsData] = await Promise.all([
        fetchTours(),
        fetchTravelogues(),
        fetchDestinations(),
      ]);
      if (toursData && toursData.length > 0) {
        setTours(normalizeTourTags(mergeValenciaIfMissing(toursData)));
      }
      if (traveloguesData && traveloguesData.length > 0) setTravelogues(traveloguesData);
      if (destinationsData && destinationsData.length > 0) setDestinations(destinationsData);
    } catch (e) {
      console.error("AppDataContext load error:", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const refreshTours = useCallback(async () => {
    const data = await fetchTours();
    if (data && data.length > 0) {
      setTours(normalizeTourTags(mergeValenciaIfMissing(data)));
    }
  }, []);
  const refreshTravelogues = useCallback(async () => {
    const data = await fetchTravelogues();
    if (data && data.length > 0) setTravelogues(data);
  }, []);
  const refreshDestinations = useCallback(async () => {
    const data = await fetchDestinations();
    if (data && data.length > 0) setDestinations(data);
  }, []);

  const value = {
    tours,
    setTours,
    travelogues,
    setTravelogues,
    destinations,
    setDestinations,
    loading,
    refreshTours,
    refreshTravelogues,
    refreshDestinations,
    loadData,
  };

  return <AppDataContext.Provider value={value}>{children}</AppDataContext.Provider>;
}

export function useAppData() {
  const ctx = useContext(AppDataContext);
  if (!ctx) throw new Error("useAppData must be used within AppDataProvider");
  return ctx;
}
